import PropTypes from 'prop-types';
import React from 'react';
import { Offcanvas } from 'react-bootstrap';

import './style.scss';
import { IconClose } from 'svgIcons/MotionPortalIcons';


const GeneralDrawerComponent = ({
    show,
    close,
    title,
    closeButton,
    headerIcon,
    drawerClassName,
    backdropClassName,
    id,
    backdrop,
    scroll,
    children,
    placement = 'end'
}) => {
    return (
        <Offcanvas
            className={'general-drawer-container ' + (drawerClassName || '')}
            backdropClassName={backdropClassName || 'general-drawer-backdrop'}
            id={id}
            show={show}
            onHide={close}
            placement={placement}
            backdrop={backdrop}
            scroll={scroll}
        >
            {<Offcanvas.Header>
                <div className='general-drawer-header'>
                    {headerIcon && <div className='general-drawer-icon'>{headerIcon}</div>}
                    <div className='general-drawer-title'>{title}</div>
                </div>
                {closeButton &&
                    <button className='close-icon' onClick={close} type='button'>
                        <IconClose />
                    </button>
                }
            </Offcanvas.Header>}
            {children && <Offcanvas.Body>{children}</Offcanvas.Body>}
        </Offcanvas>
    );
};

GeneralDrawerComponent.propTypes = {
    children: PropTypes.any,
    close: PropTypes.any,
    notificationType: PropTypes.any,
    show: PropTypes.any,
    title: PropTypes.any,
    persistent: PropTypes.bool
};

export default GeneralDrawerComponent;
